import abi from './abi.json'
const address = "0x55d398326f99059fF775485246999027B3197955"
const usdt = {abi,address}
export default usdt